import { observer } from 'mobx-react';
import * as React from 'react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { MessageBarButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import store from '../store/store';
import DomainEnrollOptionFull from './DomainEnrollOptionFull';
import { removeDomain } from '../actions/removeDomain';
import { manageDomainClick } from '../actions/manageDomainClick';
import { createEmail } from '../actions/createEmail';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { getPremiumUser } from '../actions/getPremiumUser';
import { fetchAndValidateDomain } from '../actions/fetchAndValidateDomain';
import { traceDomainUIStatue } from '../utils/domainOptionTracer';
import addHours from 'date-fns/add_hours';
import { List } from 'office-ui-fabric-react/lib/List';
import { getSecondarySubscribers } from '../actions/getSecondarySubscribers';
import { PremiumUserResponse as SecondarySubscriber } from '../contracts/premiumUserResponse';
import { format } from 'owa-strings';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { removeEmail } from '../actions/removeEmail';
import { Label } from 'office-ui-fabric-react/lib/Label';

const styles = require('./DomainOptionFull.scss');

@observer
export default class DomainOptionFull extends React.Component<{}, {}> {
    componentDidMount() {
        getPremiumUser();
        fetchAndValidateDomain();
        getSecondarySubscribers();
    }

    render() {
        if (store.domainState.isDomainCreated) {
            var messageType: MessageBarType;
            var messageText;
            var isShowCreateEmailButton = false;
            var isShowWarningButton = false;
            var isShowRemoveDomainButton = false;
            var today = new Date();
            var isDomainCreated24HoursAgo: boolean = false;
            if (
                store.domainState.domainPurchaseDate &&
                addHours(store.domainState.domainPurchaseDate, 24) < today
            ) {
                isDomainCreated24HoursAgo = true;
            }

            if (store.domainState.isValid) {
                if (store.userInfo.isProsumerConsumerMailbox) {
                    messageType = MessageBarType.success;
                    messageText = strings.options_premiumSubOption_SuccessText;
                    isShowRemoveDomainButton = true;
                } else {
                    messageType = MessageBarType.warning;
                    messageText = strings.options_premiumSubOption_CreateEmailText;
                    isShowWarningButton = true;
                    isShowCreateEmailButton = true;
                }
            } else {
                if (isDomainCreated24HoursAgo) {
                    messageType = MessageBarType.error;
                    messageText = strings.options_premiumSubOption_ErrorText;
                } else {
                    messageType = MessageBarType.info;
                    messageText = strings.options_premiumSubOption_WarningText;
                }
                isShowWarningButton = true;
            }

            traceDomainUIStatue(store.userInfo.isProsumerConsumerMailbox, messageType.toString());
            messageText = messageText.replace('{0}', store.domainState.domainName);

            return (
                <div>
                    <div>
                        <div className={styles.domain_text_container}>
                            {strings.options_premium_PersonalEmail_description1}
                        </div>
                        <div className={styles.domain_btn_container}>
                            <PrimaryButton
                                text={strings.options_premium_buttonText}
                                data-is-focusable={true}
                                disabled={false}
                                onClick={manageDomainClick}
                            />
                        </div>
                    </div>

                    <div className={styles.messagebar}>
                        {store.domainState.isValidatingDomain && (
                            <div className={styles.waitingSpin}>
                                <Spinner size={SpinnerSize.medium} className={styles.spinner} />
                            </div>
                        )}
                        {!store.domainState.isValidatingDomain && (
                            <MessageBar
                                messageBarType={messageType}
                                isMultiline={true}
                                actions={
                                    <div>
                                        {store.domainState.isRemovingDomain && (
                                            <Spinner
                                                size={SpinnerSize.medium}
                                                className={styles.spinner}
                                            />
                                        )}
                                        {isShowCreateEmailButton && (
                                            <MessageBarButton
                                                onClick={createEmail}
                                                disabled={store.domainState.isRemovingDomain}>
                                                {strings.options_premiumSubOption_CreateEmailButton}
                                            </MessageBarButton>
                                        )}
                                        {isShowWarningButton && (
                                            <MessageBarButton
                                                onClick={removeDomain}
                                                disabled={store.domainState.isRemovingDomain}>
                                                {strings.options_premiumSubOption_WarningButton}
                                            </MessageBarButton>
                                        )}
                                        {isShowRemoveDomainButton && (
                                            <MessageBarButton
                                                onClick={removeDomain}
                                                disabled={store.domainState.isRemovingDomain}>
                                                {
                                                    strings.options_premiumSubOption_RemoveDomainButton
                                                }
                                            </MessageBarButton>
                                        )}
                                    </div>
                                }>
                                {messageText}
                                <a
                                    href="https://go.microsoft.com/fwlink/?linkid=871933"
                                    target="_blank">
                                    {strings.options_premium_AdvancedSecurityContent_LearnMore}
                                </a>
                            </MessageBar>
                        )}
                    </div>

                    {(store.userInfo.isProsumerConsumerMailbox ||
                        store.secondarySubscribersInfo.length > 0) && (
                        <div>
                            <div className={styles.members_container}>
                                <div className={styles.members_header}>
                                    {strings.options_premium_PersonalEmail_MembersTitle}
                                </div>

                                <div className={styles.container}>
                                    {store.userInfo.isProsumerConsumerMailbox && (
                                        <div className={styles.alias}>
                                            <div className={styles.user}>
                                                <Label className={styles.name}>
                                                    {' '}
                                                    {format(
                                                        '{0} {1}',
                                                        store.userInfo.firstName,
                                                        store.userInfo.lastName
                                                    )}{' '}
                                                </Label>
                                                <Label className={styles.address}>
                                                    {' '}
                                                    {store.userInfo.prosumerEmailAddress}{' '}
                                                </Label>
                                                <Label className={styles.role} disabled={true}>
                                                    {' '}
                                                    {
                                                        strings.options_premium_DomainAdministratorText
                                                    }{' '}
                                                </Label>
                                            </div>

                                            <div className={styles.action}>
                                                {store.userInfo.isRemovingEmailAddress && (
                                                    <Spinner
                                                        size={SpinnerSize.medium}
                                                        className={styles.spinner}
                                                    />
                                                )}
                                                <ActionButton
                                                    text={strings.options_premium_RemoveAddressText}
                                                    onClick={removeEmail}
                                                    disabled={store.userInfo.isRemovingEmailAddress}
                                                    iconProps={{
                                                        iconName: ControlIcons.Delete,
                                                        styles: { root: styles.actionButton },
                                                    }}
                                                    styles={{
                                                        label: styles.actionLabel,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <List
                                        items={store.secondarySubscribersInfo}
                                        onRenderCell={this.renderSecondarySubscribers}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return <DomainEnrollOptionFull />;
        }
    }

    private renderSecondarySubscribers = (item?: any) => {
        const secondarySubscriber = item as SecondarySubscriber;
        return (
            <div className={styles.alias}>
                <div className={styles.user}>
                    <Label className={styles.name}>
                        {' '}
                        {format(
                            '{0} {1}',
                            secondarySubscriber.firstName,
                            secondarySubscriber.lastName
                        )}{' '}
                    </Label>
                    <Label className={styles.address}>
                        {' '}
                        {secondarySubscriber.prosumerEmailAddress}{' '}
                    </Label>
                    <Label className={styles.role} disabled={true}>
                        {' '}
                        {strings.options_premium_NormalUserText}{' '}
                    </Label>
                </div>
            </div>
        );
    };
}
